// Song header (SP1) — thin wrapper over <bw-song-header>. Read-only on web:
// no editable duration/notes. Data flows one-way from the manifest.

import '@bandway/ui-components';
import type { ShareManifest } from '@bandway/share-types';

export interface SongHeaderHandle { unmount: () => void; }

export function mountSongHeader(host: Element, manifest: ShareManifest): SongHeaderHandle {
  const el = document.createElement('bw-song-header') as HTMLElement & {
    song: { name?: string; key?: string; bpm?: number; timeSignature?: string; duration?: number };
    compact: boolean;
  };
  el.song = {
    name: manifest.song.name,
    key: manifest.song.key,
    bpm: manifest.song.bpm,
    timeSignature: manifest.song.timeSignature,
    duration: manifest.duration,
  };
  el.compact = true;
  host.appendChild(el);

  return { unmount: () => { try { host.removeChild(el); } catch { /* noop */ } } };
}
